module.exports = __webpack_public_path__ + "8cabad98ca61a1cf1bda759d0368147e.svg";